module.exports = __webpack_public_path__ + "img/Platform_Gradients-13.ffa53678.jpg";